// src/components/aols/aeo/OLSupdates/OLS1500/OLS1500.tsx
import React from "react";
import { Update } from "../OLS1000/OLS1000";

export const updates1500: Update[] = [
  { id: "1500", text: "OLSM__" },
  { id: "1499", text: "OLSM__" },
  { id: "1498", text: "OLSM__" },
  { id: "1497", text: "OLSM__" },
  { id: "1496", text: "OLSM__" },
  { id: "1495", text: "OLSM__" },
  { id: "1494", text: "OLSM__" },
  { id: "1493", text: "OLSM__" },
  { id: "1492", text: "OLSM__" },
  { id: "1491", text: "OLSM__" },
  { id: "1490", text: "OLSM__" },
  { id: "1489", text: "OLSM__" },
  { id: "1488", text: "OLSM__" },
  { id: "1487", text: "OLSM__" },
  { id: "1486", text: "OLSM__" },
  { id: "1485", text: "OLSM__" },
  { id: "1484", text: "OLSM__" },
  { id: "1483", text: "OLSM__" },
  { id: "1482", text: "OLSM__" },
  { id: "1481", text: "OLSM__" },
  { id: "1480", text: "OLSM__" },
  { id: "1479", text: "OLSM__" },
  { id: "1478", text: "OLSM__" },
  { id: "1477", text: "OLSM__" },
  { id: "1476", text: "OLSM__" },
  { id: "1475", text: "OLSM__" },
  { id: "1474", text: "OLSM__" },
  { id: "1473", text: "OLSM__" },
  { id: "1472", text: "OLSM__" },
  { id: "1471", text: "onelightsystem OLS Founder CEO announcing OLS9LM executive availability assets 5.4% a.826 (4 years anniversary)", link: "https://onelightsystem.blogspot.com/2021/05/1471onelightsystem-ols-founder-ceo.html" },
  { id: "1470", text: "OLSM__" },
  { id: "1469", text: "OLSM__" },
  { id: "1468", text: "OLSM__" },
  { id: "1467", text: "OLSM__" },
  { id: "1466", text: "OLSM__" },
  { id: "1465", text: "OLSM__" },
  { id: "1464", text: "OLSM__" },
  { id: "1463", text: "OLSM__" },
  { id: "1462", text: "OLSM__" },
  { id: "1461", text: "OLSM__" },
  { id: "1460", text: "OLSM__" },
  { id: "1459", text: "OLSM__" },
  { id: "1458", text: "OLSM__" },
  { id: "1457", text: "OLSM__" },
  { id: "1456", text: "OLSM__" },
  { id: "1455", text: "OLSM__" },
  { id: "1454", text: "OLSM__" },
  { id: "1453", text: "OLSM__" },
  { id: "1452", text: "OLSM__" },
  { id: "1451", text: "OLSM__" },
  { id: "1450", text: "OLSM__" },
  { id: "1449", text: "OLSM__" },
  { id: "1448", text: "OLSM__ OLS iee.aeo 13LH" },
  { id: "1447", text: "OLSM__" },
  { id: "1446", text: "OLSM__" },
  { id: "1445", text: "OLSM__" },
  { id: "1444", text: "OLSM__" },
  { id: "1443", text: "OLSM__" },
  { id: "1442", text: "OLSM__" },
  { id: "1441", text: "OLSM__" },
  { id: "1440", text: "OLSM__" },
  { id: "1439", text: "OLSM__" },
  { id: "1438", text: "OLSM__" },
  { id: "1437", text: "OLSM__" },
  { id: "1436", text: "OLSM__" },
  { id: "1435", text: "OLSM__" },
  { id: "1434", text: "OLSM__" },
  { id: "1433", text: "OLSM__" },
  { id: "1432", text: "OLSM__" },
  { id: "1431", text: "OLSM__" },
  { id: "1430", text: "OLSM__" },
  { id: "1429", text: "OLSM__" },
  { id: "1428", text: "OLSM__" },
  { id: "1427", text: "OLSM__" },
  { id: "1426", text: "OLSM__" },
  { id: "1425", text: "OLSM__" },
  { id: "1424", text: "OLSM__" },
  { id: "1423", text: "OLSM__" },
  { id: "1422", text: "OLS 3.4 iee.aeo [E 12LH ] 03/16/2022" },
  { id: "1421", text: "OLSM__" },
  { id: "1420", text: "OLSM__" },
  { id: "1419", text: "OLSM__" },
  { id: "1418", text: "OLSM__" },
  { id: "1417", text: "OLSM__" },
  { id: "1416", text: "OLSM__" },
  { id: "1415", text: "OLSM__" },
  { id: "1414", text: "OLSM__" },
  { id: "1413", text: "OLSM__" },
  { id: "1412", text: "OLSM__" },
  { id: "1411", text: "OLSM__" },
  { id: "1410", text: "OLSM__" },
  { id: "1409", text: "OLSM__" },
  { id: "1408", text: "OLSM__" },
  { id: "1407", text: "OLSM__" },
  { id: "1406", text: "OLSM__" },
  { id: "1405", text: "OLSM__" },
  { id: "1404", text: "OLSM__" },
  { id: "1403", text: "OLSM__" },
  { id: "1402", text: "OLSM__" },
  { id: "1401", text: "OLSM__" },
  { id: "1400", text: "OLSM__" },
  { id: "1399", text: "OLSM__" },
  { id: "1398", text: "OLSM__" },
  { id: "1397", text: "OLSM__" },
  { id: "1396", text: "OLSM__" },
  { id: "1395", text: "OLSM__" },
  { id: "1394", text: "OLSM__" },
  { id: "1393", text: "OLSM__" },
  { id: "1392", text: "OLSM__" },
  { id: "1391", text: "OLSM__" },
  { id: "1390", text: "onelightsystem OLS Founder CEO announcing OLSLM assets availability 6.9107% A.1352.4562", link: "https://onelightsystem.blogspot.com/2021/02/1390onelightsystem-ols-founder-ceo.html" },
  { id: "1389", text: "OLSM__" },
  { id: "1388", text: "OLS iee.aeo [Mercury e. I] 02/06 - 02/11/2022", link: "https://onelightsystem.blogspot.com" },
  { id: "1387", text: "OLSM__" },
  { id: "1386", text: "OLSM__" },
  { id: "1385", text: "OLSM__" },
  { id: "1384", text: "OLSM__" },
  { id: "1383", text: "OLSM__" },
  { id: "1382", text: "OLSM__" },
  { id: "1381", text: "OLSM__" },
  { id: "1380", text: "OLSM__" },
  { id: "1379", text: "OLSM__" },
  { id: "1378", text: "OLSM__" },
  { id: "1377", text: "OLSM__" },
  { id: "1376", text: "onelightsystem OLS Founder CEO announcing OLSLM assets availability 7.6016% A.1483.2036", link: "https://onelightsystem.blogspot.com/2021/01/1376ols-founder-ceo-nazar-announcing_29.html" },
  { id: "1375", text: "OLSM__" },
  { id: "1374", text: "OLSM__" },
  { id: "1373", text: "OLSM__" },
  { id: "1372", text: "OLSM__" },
  { id: "1371", text: "OLSM__" },
  { id: "1370", text: "OLSM__" },
  { id: "1369", text: "OLSM__" },
  { id: "1368", text: "OLSM__" },
  { id: "1367", text: "OLSM__" },
  { id: "1366", text: "OLSM__" },
  { id: "1365", text: "OLSM__" },
  { id: "1364", text: "onelightsystem OLS Founder CEO announcing OLSLM assets availability 8.9828% A.1746.2451", link: "https://onelightsystem.blogspot.com/2021/01/1364ols-founder-ceo-nazar-announcing.html" },
  { id: "1363", text: "OLSM__" },
  { id: "1362", text: "OLSM__" },
  { id: "1361", text: "OLSM__" },
  { id: "1360", text: "OLSM__" },
  { id: "1359", text: "OLSM__" },
  { id: "1358", text: "OLSM__" },
  { id: "1357", text: "OLSM__" },
  { id: "1356", text: "OLSM__" },
  { id: "1355", text: "OLSM__" },
  { id: "1354", text: "OLSM__" },
  { id: "1353", text: "OLSM__" },
  { id: "1352", text: "OLSM__" },
  { id: "1351", text: "OLSM__" },
  { id: "1350", text: "onelightsystem OLS Founder CEO announcing OLSLM assets availability 9.675% a. 1876.7762", link: "https://onelightsystem.blogspot.com/2021/01/1350ols-founder-ceo-nazar-announcing.html" },
  { id: "1349", text: "OLSM__" },
  { id: "1348", text: "OLSM__" },
  { id: "1347", text: "OLSM__" },
  { id: "1346", text: "OLSM__" },
  { id: "1345", text: "OLSM__" },
  { id: "1344", text: "OLS 3.3 Calendar", link: "https://onelightsystem.blogspot.com/2020/12/1344ols-33-calendar-wwwolsmecom.html" },
  { id: "1343", text: "OLSM__" },
  { id: "1342", text: "OLSM__" },
  { id: "1341", text: "OLSM__" },
  { id: "1340", text: "OLSM__" },
  { id: "1339", text: "OLSM__" },
  { id: "1338", text: "OLSM__" },
  { id: "1337", text: "OLSM__" },
  { id: "1336", text: "OLS 3.3 iee.aeo [a correct New Light Year]", link: "https://youtu.be/UlKs0vJxNc0" },
  { id: "1335", text: "OLSM__" },
  { id: "1334", text: "OLSM__" },
  { id: "1333", text: "OLSM__" },
  { id: "1332", text: "OLSM__" },
  { id: "1331", text: "OLSM__" },
  { id: "1330", text: "OLSM__" },
  { id: "1329", text: "OLSM__" },
  { id: "1328", text: "OLSM__" },
  { id: "1327", text: "OLSM__" },
  { id: "1326", text: "OLSM__" },
  { id: "1325", text: "OLSM__" },
  { id: "1324", text: "OLSM__" },
  { id: "1323", text: "OLSM__" },
  { id: "1322", text: "OLSM__" },
  { id: "1321", text: "OLSM__" },
  { id: "1320-1", text: "OLSM__" },
  { id: "1320-2", text: "OLS promoter OLSLM assets availability 11.75%", link: "https://onelightsystem.blogspot.com/2020/12/1319ols-ieeaeo-founder-ceo-nazar.html" },
  { id: "1319", text: "OLS6M__ 69/348 12/3" },
  { id: "1318", text: "OLSM__" },
  { id: "1317", text: "OLSM__" },
  { id: "1316", text: "OLSM__" },
  { id: "1315", text: "OLSM__" },
  { id: "1314", text: "OLSM__" },
  { id: "1313", text: "OLS promoter OLSLM assets availability 12.38%", link: "https://onelightsystem.blogspot.com/2020/11/1313ols-promoter-olslm-assets.html" },
  { id: "1312-1", text: "OLS8M__" },
  { id: "1312-2", text: "OLSLM assets availibility facebook Fundraiser", link: "https://www.facebook.com/donate/191617935944180/" },
  { id: "1311", text: "OLSM__" },
  { id: "1310", text: "OLSM__" },
  { id: "1309", text: "OLSM__" },
  { id: "1308", text: "OLSM__" },
  { id: "1307", text: "OLSM__" },
  { id: "1306", text: "OLSM__" },
  { id: "1305", text: "OLSM__" },
  { id: "1304", text: "OLSM__" },
  { id: "1303", text: "OLSM__" },
  { id: "1302", text: "OLSM__" },
  { id: "1301", text: "OL_POWER__" },
  { id: "1300", text: "OLSM__" },
  { id: "1299", text: "   ", link: "https://onelightsystem.blogspot.com/2020/11/1299ols-aeoiee-amba.html" },
  { id: "1298", text: "OLSM__" },
  { id: "1297", text: "OLSM__" },
  { id: "1296", text: "OLS 3.25 calendar", link: "https://onelightsystem.blogspot.com/2020/11/1296ols-325-calendar-wwwolsmecom.html" },
  { id: "1295", text: "OLSM__" },
  { id: "1294", text: "OLSM__" },
  { id: "1293", text: "OLSM__" },
  { id: "1292", text: "OLSM__" },
  { id: "1291", text: "OLSM__" },
  { id: "1290", text: "OLSM__" },
  { id: "1289", text: "OLSM__" },
  { id: "1288", text: "OLSM__" },
  { id: "1287", text: "OLSM__" },
  { id: "1286", text: "OLSM__" },
  { id: "1285", text: "OLSM__" },
  { id: "1284", text: "OLSM__" },
  { id: "1283", text: "OLSM__" },
  { id: "1282", text: "OLSM__" },
  { id: "1281", text: "OLSM__" },
  { id: "1280", text: "OLSM__" },
  { id: "1279", text: "OLSM__" },
  { id: "1278", text: "OLSM__" },
  { id: "1277", text: "OLS amba iee. [Mercury Eclipse 10/21 - 25]" },
  { id: "1276", text: "OLSM__" },
  { id: "1275", text: "OLSM__" },
  { id: "1274", text: "OLSM__" },
  { id: "1273", text: "OLSM__" },
  { id: "1272", text: "OLSM__" },
  { id: "1271", text: "OLSM__" },
  { id: "1270", text: "OLS_M__" },
  { id: "1269", text: "OLSM__" },
  { id: "1268", text: "OLSM__" },
  { id: "1267", text: "OLSM__" },
  { id: "1266", text: "OLSM__" },
  { id: "1265", text: "OLSM__" },
  { id: "1264", text: "OLSM__" },
  { id: "1263", text: "OLSM__" },
  { id: "1262", text: "OLSM__" },
  { id: "1261", text: "OLS amba iee. [Mars Transition 10/8 - 25]" },
  { id: "1260", text: "OLSM__" },
  { id: "1259", text: "OLSM__" },
  { id: "1258", text: "OLSM__" },
  { id: "1257", text: "OLSM__" },
  { id: "1256", text: "OLSM__" },
  { id: "1255", text: "OLSM__" },
  { id: "1254", text: "OLSM__" },
  { id: "1253", text: "OLSM__" },
  { id: "1252", text: "OLS_M__" },
  { id: "1251", text: "OLSM__" },
  { id: "1250", text: "OLS 3.2 E.12LH. [9/25]", link: "https://youtu.be/_xzcO8dRTQA" },
  { id: "1249", text: "OLSM__" },
  { id: "1248", text: "OLSM__" },
  { id: "1247", text: "OLSM__" },
  { id: "1246", text: "OLSM__" },
  { id: "1245", text: "OLSM__" },
  { id: "1244", text: "OLSM__" },
  { id: "1243", text: "OLSM__" },
  { id: "1242", text: "OLSM__" },
  { id: "1241", text: "OLSM__" },
  { id: "1240", text: "OLSM__" },
  { id: "1239", text: "OLSM__" },
  { id: "1238", text: "OLSM__" },
  { id: "1237", text: "OLSM__" },
  { id: "1236", text: "OLSM__" },
  { id: "1235", text: "OLSM__" },
  { id: "1234", text: "OLSM__" },
  { id: "1233", text: "OLS iee. amba Neptune transition 9/8" },
  { id: "1232", text: "OLSM__" },
  { id: "1231", text: "OLSM__" },
  { id: "1230", text: "OLSM__" },
  { id: "1229", text: "OLSM__" },
  { id: "1228", text: "OLSM__" },
  { id: "1227", text: "OLSM__" },
  { id: "1226", text: "OLSM__" },
  { id: "1225", text: "OLSM__" },
  { id: "1224", text: "OLSM__" },
  { id: "1223", text: "OLS_M__" },
  { id: "1222", text: "OLSM__" },
  { id: "1221", text: "OLSM__" },
  { id: "1220", text: "OLSM__" },
  { id: "1219", text: "OLSM__" },
  { id: "1218", text: "OLSM__" },
  { id: "1217", text: "OLSM__" },
  { id: "1216", text: "OLSM__" },
  { id: "1215", text: "OLSM__" },
  { id: "1214", text: "OLSM__" },
  { id: "1213", text: "OLSM__" },
  { id: "1212", text: "OLSM__" },
  { id: "1211", text: "OLSM__" },
  { id: "1210", text: "OLSM__" },
  { id: "1209", text: "OLSM__" },
  { id: "1208", text: "OLSM__" },
  { id: "1207", text: "OLSM__" },
  { id: "1206", text: "OLS_M__" },
  { id: "1205", text: "OLSM__" },
  { id: "1204", text: "OLSM__" },
  { id: "1203", text: "OLSM__" },
  { id: "1202", text: "OLSM__" },
  { id: "1201", text: "OLSM__" },
  { id: "1200", text: "OLSM__" },
  { id: "1199", text: "OLSM__" },
  { id: "1198", text: "OLSM__" },
  { id: "1197", text: "OLSM__" },
  { id: "1196", text: "OLSM__" },
  { id: "1195", text: "OLSM__" },
  { id: "1194", text: "OLSM__" },
  { id: "1193", text: "OLSM__" },
  { id: "1192", text: "OLSM__" },
  { id: "1191", text: "OLSM__" },
  { id: "1190", text: "OLSM__" },
  { id: "1189", text: "OLSM__" },
  { id: "1188", text: "OLSM__" },
  { id: "1187", text: "OLSM__" },
  { id: "1186", text: "OLSM__" },
  { id: "1185", text: "OLSM__" },
  { id: "1184", text: "OLSM__" },
  { id: "1183", text: "OLSM__" },
  { id: "1182", text: "OLSM__" },
  { id: "1181", text: "OLSM__" },
  { id: "1180", text: "OLSM__" },
  { id: "1179", text: "OLSM__" },
  { id: "1178", text: "OLSM__" },
  { id: "1177", text: "OLSM__" },
  { id: "1176", text: "OLSM__" },
  { id: "1175", text: "203/22. OLS ieense [07/12 - 16/2020 Jupiter Saturn]" },
  { id: "1174", text: "OLSM__" },
  { id: "1173", text: "OLSM__" },
  { id: "1172", text: "201/20. OLS iee.aeo (LIVE Q/A on-boarding)", link: "https://youtu.be/elNBEItC4vo" },
  { id: "1171", text: "OLSM__" },
  { id: "1170-1", text: "OLSLM 3045.45615 assets availability to public update", link: "https://youtu.be/GGLtQstFB8w" },
  { id: "1170-2", text: "[Live OLSLM]", link: "https://www.facebook.com/watch/?v=285313842882562" },
  { id: "1169", text: "OLSM___" },
  { id: "1168", text: "OLSM___" },
  { id: "1167", text: "OLSM___" },
  { id: "1166", text: "OLSM___" },
  { id: "1165", text: "OLSM___" },
  { id: "1164", text: "OLSM___" },
  { id: "1163", text: "OLSM___" },
  { id: "1162", text: "OLSM___" },
  { id: "1161", text: "OLSM___. [new format]" },
  { id: "1160", text: "OLSM___" },
];

const OLSupdates1500: React.FC = () => null;
export default OLSupdates1500;